<template>
  <v-dialog
    scrollable
    :value="opened"
    v-if="opened"
    :transition="false"
    :persistent="false"
    @click:outside="opened = false"
  >
    <v-card min-height="820px" class="overflow-y-hidden">
      <v-card-title class="headline"/>
      <v-card-text>
        <v-tabs v-model="tab" fixed-tabs>
          <v-tab>Загрузить</v-tab>
          <v-tab v-if="!payloadOnly">Выбрать из медиа-библиотеки</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
              <v-row>
                <v-col>
                  <MediaFileLoader
                    :file-type="fileType"
                    :multiple="multiple"
                    :return-file-only="returnFileOnly"
                    @files-uploaded="uploadFiles"
                    @close-dialog="close"
                  />
                </v-col>
              </v-row>
          </v-tab-item>
          <v-tab-item>
              <v-row>
                <v-col>
                  <MediaLibraryFilePicker
                    ref="library"
                    v-if="opened"
                    :file-type="fileType"
                    :value="value"
                    @change="uploadFiles"
                  />
                </v-col>
              </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions>
        <slot name="actions">
          <v-spacer/>
          <!-- <v-btn
            text
            color="grey darken-2"
            @click.prevent="close"
          >Отмена</v-btn> -->
          <v-btn
            text
            color="primary darken-2"
            @click="close"
          >
            Закрыть
          </v-btn>
          </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import MediaFileLoader from '@/components/media-file-loader'
import MediaLibraryFilePicker from './media-library-file-picker'
import AbstractDialog from '@/components/abstract/dialog'
export default {
  name: 'UploadDialog',
  components: {
    MediaFileLoader,
    MediaLibraryFilePicker
  },
  extends: AbstractDialog,
  props: {
    value: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    fileType: {
      type: Object,
      default: () => ({})
    },
    payloadOnly: {
      type: Boolean,
      default: false
    },
    returnFileOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tab: 0
    }
  },
  methods: {
    uploadFiles (fileId) {
      this.$emit('change', fileId)
    }
  }
}
</script>
